import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, SpecraCard, SpecraCardContent, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useQuery } from '@tanstack/react-query';
import { projectDataClient } from '../../../../lib/connect/clients';
import { SourceContent } from '../../../../pages/Capture/Outputs/SourceContent';
export function CaptureOutputBaselines({ projectId }) {
    const query = useQuery({
        queryKey: [
            'proposal-output-baselines',
            projectId
        ],
        queryFn: ()=>projectDataClient.listCaptureOutputHandoffs({
                proposalProjectId: projectId
            }),
        retry: false
    });
    if (query.isLoading) return /*#__PURE__*/ _jsx(Skeleton, {
        className: "h-16 w-full"
    });
    if (query.isError) return /*#__PURE__*/ _jsx(SpecraText, {
        role: "alert",
        children: "Capture baselines could not be loaded. Reload to retry or request source access."
    });
    return /*#__PURE__*/ _jsx(SpecraCard, {
        children: /*#__PURE__*/ _jsxs(SpecraCardContent, {
            className: "space-y-3",
            children: [
                /*#__PURE__*/ _jsx(SpecraText, {
                    children: "Reusable Capture baselines"
                }),
                /*#__PURE__*/ _jsx(SpecraText, {
                    children: "Selected upstream intelligence only. Adoption into Proposal content is separate; no technical volume or submitted price is approved here."
                }),
                !query.data?.handoffs.length && /*#__PURE__*/ _jsx(SpecraText, {
                    children: "No baselines available with your current source permissions."
                }),
                query.data?.handoffs.map((baseline)=>/*#__PURE__*/ _jsxs("section", {
                        "data-testid": Testids.captureOutputHandoff.baseline,
                        "data-version-id": baseline.outputVersionId,
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ _jsxs(SpecraText, {
                                children: [
                                    "Capture output version ",
                                    baseline.content?.version,
                                    " · accepted ",
                                    baseline.createdAt
                                ]
                            }),
                            baseline.content?.projection?.sections.map((section)=>/*#__PURE__*/ _jsxs("section", {
                                    className: "space-y-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(SpecraText, {
                                            children: section.title
                                        }),
                                        baseline.content?.overrides.filter((o)=>o.sectionKey === section.key).map((o)=>/*#__PURE__*/ _jsx(SpecraText, {
                                                children: o.wording
                                            }, o.sectionKey)),
                                        section.sources.map((source)=>/*#__PURE__*/ _jsx(SourceContent, {
                                                content: source.contentJson
                                            }, `${source.kind}:${source.id}:${source.version}`))
                                    ]
                                }, section.key))
                        ]
                    }, baseline.id))
            ]
        })
    });
}
